import { Box, Divider, Flex, Heading, Link, Stack, Text } from '@chakra-ui/react';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
import { Seo } from '../components/Seo';
import { PageHeader } from '../components/PageHeader';
import { Section } from '../components/Section';
import { ContactForm } from '../components/ContactForm';
import { Disclaimer } from '../components/Disclaimer';
import { company } from '../data/site';
const MAP_SRC = 'https://www.openstreetmap.org/export/embed.html?bbox=-80.2900%2C26.0900%2C-80.2450%2C26.1250&layer=mapnik&marker=26.1075%2C-80.2675';
export function Contact() {
  return <>
      <Seo title="Contact Futuramy Investment LLC" description="Contact Futuramy Investment LLC in Plantation, Florida. We welcome professional inquiries, business opportunities and partnership discussions." path="/contact" data-id="element-206" data-mp="17qqt2qhxosng" />
      <PageHeader eyebrow="Contact" title="Contact Futuramy" subtitle="We welcome professional inquiries, business opportunities and partnership discussions." data-id="element-207" data-mp="f83g5yd3cjxg" />

      <Section data-id="element-208" data-mp="15dcgpkcs2u5m">
        <Flex direction={{
        base: 'column',
        lg: 'row'
      }} gap={{
        base: 12,
        lg: 20
      }} align="flex-start" data-id="element-209" data-mp="19h0oa31etpqv">
          <Box flex="1.3" w="100%" data-id="element-210" data-mp="1e7qrpaq9ziix">
            <Heading as="h2" fontSize={{
            base: 'xl',
            md: '2xl'
          }} mb={3} data-id="element-211" data-mp="1e8s4bjmxwd2r">
              Send an Inquiry
            </Heading>
            <Text fontSize="sm" color="navy.500" mb={10} maxW="560px" lineHeight={1.8} data-id="element-212" data-mp="1j622posb3z2q">
              Complete the form below and a member of our team will review your inquiry.
            </Text>
            <ContactForm data-id="element-213" data-mp="qiob867dnvq0" />
          </Box>

          <Box flex="1" w="100%" data-id="element-214" data-mp="vhiu185chka4">
            <Stack spacing={8} data-id="element-215" data-mp="vg7p3505y6hf">
              <Box border="1px solid" borderColor="navy.100" bg="navy.50" p={{
              base: 7,
              md: 8
            }} data-id="element-216" data-mp="vjc3ev7ceilt">
                <Text fontSize="xs" fontWeight={600} letterSpacing="0.16em" textTransform="uppercase" color="accent.600" mb={6} data-id="element-217" data-mp="10e98xs5ey9ty">
                  Company Information
                </Text>
                <Heading as="h2" fontSize="lg" mb={6} data-id="element-218" data-mp="1m96lv34hohsn">
                  {company.legalName}
                </Heading>
                <Stack spacing={5} data-id="element-219" data-mp="1w59kw041o0bd">
                  <Flex gap={4} align="flex-start" data-id="element-220" data-mp="1w48be02oflvr">
                    <Box as={MapPinIcon} boxSize={5} color="navy.400" mt={0.5} flexShrink={0} aria-hidden data-id="element-221" data-mp="1r6gfyw2tphmt" />
                    <Box fontSize="sm" color="navy.600" lineHeight={1.8} data-id="element-222" data-mp="13gm3wgqbvx3m">
                      <Text data-id="element-223" data-mp="13ej5b8b40vna">{company.addressLine1}</Text>
                      <Text data-id="element-224" data-mp="yj3ukp8effv3">{company.addressLine2}</Text>
                      <Text data-id="element-225" data-mp="1d6f5qq0o4xuo">{company.addressLine3}</Text>
                    </Box>
                  </Flex>
                  <Divider borderColor="navy.100" data-id="element-226" data-mp="18g8j2vppvnf2" />
                  <Flex gap={4} align="center" data-id="element-227" data-mp="18enpb8b888i9">
                    <Box as={PhoneIcon} boxSize={5} color="navy.400" flexShrink={0} aria-hidden data-id="element-228" data-mp="kpuph0rhhgid" />
                    <Text fontSize="sm" color="navy.600" data-id="element-229" data-mp="frjicxskpk3u">
                      Phone:{' '}
                      <Link href={company.phoneHref} color="accent.600" _hover={{
                      color: 'navy.800'
                    }} data-id="element-230" data-mp="2rewq7uy9ai0a">
                        {company.phone}
                      </Link>
                    </Text>
                  </Flex>
                </Stack>
              </Box>

              <Box border="1px solid" borderColor="navy.100" overflow="hidden" data-id="element-231" data-mp="2hedxeaoprr68">
                <Box as="iframe" title={`Map showing the location of ${company.legalName} in Plantation, Florida`} src={MAP_SRC} w="100%" h="300px" border="0" loading="lazy" data-id="element-232" data-mp="2mg39zurl4cwf" />
              </Box>
            </Stack>
          </Box>
        </Flex>
      </Section>

      <Disclaimer data-id="element-233" data-mp="354goangw6r39" />
    </>;
}